import { render, staticRenderFns } from "./ProviderReferences.vue?vue&type=template&id=6864557d&"
import script from "./ProviderReferences.vue?vue&type=script&lang=js&"
export * from "./ProviderReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports